import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
/**
 * SegmentedControl - a compact, token-driven segmented toggle (the canonical
 * version of the one-off `.deal-view-page__toggle`). One value is active at a
 * time; the active segment fills with the accent. Keyboard + `aria-pressed`
 * accessible, motion gated on `prefers-reduced-motion` (in components.css).
 */
export function SegmentedControl({ options, value, onChange, size = 'compact', ariaLabel, disabled = false, className, }) {
    return (_jsx("div", { className: clsx('segmented', `segmented--${size}`, className), role: "group", "aria-label": ariaLabel, children: options.map((option) => {
            const active = option.value === value;
            const iconOnly = option.label == null && option.icon != null;
            return (_jsxs("button", { type: "button", className: clsx('segmented__btn', active && 'segmented__btn--active', iconOnly && 'segmented__btn--icon'), "aria-pressed": active, "aria-label": option.ariaLabel, disabled: disabled || option.disabled, onClick: () => {
                    if (!active)
                        onChange(option.value);
                }, children: [option.icon ? _jsx("span", { className: "segmented__icon", children: option.icon }) : null, option.label != null ? _jsx("span", { className: "segmented__label", children: option.label }) : null] }, option.value));
        }) }));
}
//# sourceMappingURL=SegmentedControl.js.map